import PageManageTasks from "./PageManageTasks.vue";
import PageMobileManageOverlock from "./mobile/PageMobileManageOverlock.vue";
import PageMobilePreInstallThreshold from "./mobile/PageMobilePreInstallThreshold.vue";

const routes = {
  navigation: [
    {
      path: "/manage-tasks",
      name: "ManageTasks",
      component: PageManageTasks,
    },
    {
      path: "/manage-tasks/:taskId/manage-overlock",
      name: "MobileManageOverlock",
      component: PageMobileManageOverlock,
      meta: { withoutAuth: true },
    },
    {
      path: "/manage-tasks/:taskId/remove-overlock",
      name: "MobileRemoveOverlock",
      component: PageMobileManageOverlock,
      meta: { withoutAuth: true },
    },
    {
      path: "/manage-tasks/:taskId/pre-install",
      name: "MobilePreInstallThreshold",
      component: PageMobilePreInstallThreshold,
      meta: { withoutAuth: true },
    },
  ],
};
export default routes;
